module.exports = __webpack_public_path__ + "img/vexere.bb00715c.png";